if (!customElements.get('cinoton-inview-video')) {
  class CinotonInviewVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.inView = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.updatePlayback = this.updatePlayback.bind(this);
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.inView = entry.isIntersecting && entry.intersectionRatio >= .35;
          this.updatePlayback();
        });
      }, { threshold: .35 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.updatePlayback);
      this.reducedMotion.addEventListener?.('change', this.updatePlayback);
    }
    updatePlayback() {
      if (this.inView && !document.hidden && !this.reducedMotion.matches) {
        this.video.play().catch(() => {});
      } else {
        this.video.pause();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.updatePlayback);
      this.reducedMotion?.removeEventListener?.('change', this.updatePlayback);
      this.video?.pause();
    }
  }
  customElements.define('cinoton-inview-video', CinotonInviewVideo);
}
